// showcaseCentral Version 1.1
// Not compatible with code that use version 1.0.
//
// Requires JQuery
//
// Example HTML:
//     <head>
//         <link rel="stylesheet" type="text/css" href="css/showcase.css">
//     </head>
//     ...
//     <div class="showcaseCentralPic" style="background-image: url('imgs/pic.png')">
//     <div class="showcaseCentralPic" style="background-image: url('imgs/pic2.png')">
//     <script src="js/showcase.js"></script>
//     <script>
//         if (screen.width > 700) // Recommend that you do NOT use this
//                                 // with mobile browsers.
//             showcaseCentral.init();
//     </script>
//
// Options object is not needed, but can be passed to init() function:
//     showcaseCentral.init({margin: 100});
//
// Options:
//     margin (number)
//         default: 88
//         The minimum margin between the showcased pic and the edges of the
//         window. It is not recommended that this is less than 80 px, because
//         this margin space is used for the prev and last buttons.
//     maxWidth (number)
//         default: 2000
//         The maximum width of the showcase.
//     closeTop (number)
//         default: 0
//         How far away the close button is placed from the top of the window.
//     closeLeft (number, numeric string or false)
//         default: false
//         How far away the close button is placed from the left of the window.
//         This can be set to false, if you'd like the close button to be set
//         from the right side instead.
//     closeRight (number, numeric string or false)
//         default: 0
//         How far away the close button is placed from the right of the window.
//         This is only used if closeLeft is set to false (or some non-numeric
//         value).
//     showcaseClass (string)
//         default: "showcaseCentralPic"
//         Script will look for elements with this class name and turn them into
//         buttons for the showcase.
//     blurClass (string)
//         default: "showcaseCentralBlur"
//         Any elements with this class name will be blurred when the showcase
//         is on.
//     useBG (boolean)
//         default: true
//         When this is set to true, script will display the element's
//         background-image as the showcase.
//     useAttr (string)
//         default: "data-bg"
//         If useBG is set to false, script will look to this attribute for the
//         location of image to display as the showcase.
//         Example: <div class="showcaseCentralPic" data-bg="location/pic.png">
//     useAttr2x (string)
//         default: "data-bg"
//         For retina/hdpi screens. If useBG is set to false, script will look
//         to this attribute for the location of image to display as the
//         showcase, if the window.devicePixelRatio >= 1.3 and screen.width >
//         700px.
//         Example:
//              <div class="showcaseCentralPic"
//                  data-bg="location/pic.png"
//                  data-bg2x="location/pic@2x.png">
//              showcaseCentral.init({useBG: false, useAttr2x: "data-bg2x"});
//     noScroll (boolean)
//         default: true
//         If set to true, script will disallow scrolling when the showcase is
//         up.
//
// Reserved element IDs: showcase-bg, showcase, showcasePrevBtn, showcaseNextBtn, and showcaseClose.

var showcaseCentral = {
    pics: [],
    inited: false,
    currPic: -1,
    showcaseOn: false,
    showcaseBG: "<div id='showcase-bg' class='showcase-bg'>" +
                    "<div id='showcase' class='showcase'></div>" +
                    "<button id='showcasePrevBtn' onclick='showcaseCentral.showcasePrev()'></button>" +
                    "<button id='showcaseNextBtn' onclick='showcaseCentral.showcaseNext()'></button>" +
                    "<button id='showcaseClose' onclick='showcaseCentral.showcaseEnd();'></button>" +
                "</div>",
    bodyInitOverflowState: "",
    options: {
        margin: 88,
        maxWidth: 2000,
        closeTop: 0,
        closeLeft: false,
        closeRight: 0,
        showcaseClass: "showcaseCentralPic",
        blurClass: "showcaseCentralBlur",
        useBG: true,
        useAttr: "data-bg",
        useAttr2x: "data-bg",
        noScroll: true
    },
    showcase: function(theDiv) {
        var windowWidth = $(window).width(),
            windowHeight = $(window).height(),
            showMargin;
        $.each(this.pics, function(i, picDiv) {
            if (picDiv === theDiv) {
                showcaseCentral.currPic = i;
                return false;
            }
        });
        $("#showcase-bg").css("top", $(window).scrollTop()).fadeIn(500);
        $("." + this.options.blurClass).css("-filter","blur(5px)");
        $("#showcase").css( "width", this.options.maxWidth);
        if (windowWidth < this.options.maxWidth)
            $("#showcase").css( "width", windowWidth - (this.options.margin * 2));
        showMargin = (windowWidth - $("#showcase").width()) / 2;
        if (this.options.noScroll) {
            this.bodyInitOverflowState = $("body").css("overflow");
            $("body").css("overflow", "hidden");
        }
        $("#showcasePrevBtn, #showcaseNextBtn").css({
            height: windowHeight,
            width: showMargin
        });
        $("#showcase").css({
            height: windowHeight - (this.options.margin * 2),
            top: this.options.margin
        });
        this.showcasePic();
        this.showcaseOn = true;
    },
    showcasePic: function() {
        var retina = (window.devicePixelRatio >= 1.3 && screen.width > 700) ? true : false,
            bg = (!this.options.useBG && retina && $(this.pics[this.currPic]).attr(this.options.useAttr2x) != undefined)
                ? "url(" + $(this.pics[this.currPic]).attr(this.options.useAttr2x) + ")"
                : "url(" + $(this.pics[this.currPic]).attr(this.options.useAttr) + ")";
        if (this.inited) {
            if (this.options.useBG) {
                bg = $(this.pics[this.currPic]).css("background-image");
            }
            $("#showcase").css({backgroundImage: bg});
        }
    },
    showcaseEnd: function() {
        $("#showcase-bg").fadeOut(500);
        $("." + this.options.blurClass).css("-filter","blur(0)");
        if (this.options.noScroll) $("body").css("overflow", showcaseCentral.bodyInitOverflowState);
        this.showcaseOn = false;
    },
    showcaseNext: function() {
        if (this.currPic < this.pics.length - 1) {
            this.currPic++;
        } else {
            this.currPic = 0;
        }
        this.showcasePic();
    },
    showcasePrev: function() {
        if (this.currPic > 0) {
            this.currPic--;
        } else {
            this.currPic = this.pics.length - 1;
        }
        this.showcasePic();
    },
    init: function(opts) {
        if (typeof opts === "object") $.each(opts, function(key, optVal) { showcaseCentral.options[key] = optVal; });
        $("body").append(this.showcaseBG);
        this.pics = $("." + this.options.showcaseClass);
        $("." + this.options.showcaseClass)
            .css("cursor","pointer")
            .click(function() { showcaseCentral.showcase(this); });
        $("#showcaseClose").css({top: this.options.closeTop + "px"});
        if ($.isNumeric(this.options.closeRight)) {
            $("#showcaseClose").css("right", this.options.closeRight + "px");
        } else if ($.isNumeric(this.options.closeLeft)) {
            $("#showcaseClose").css("left", this.options.closeLeft + "px");
        }
        $(window).keydown(function(evt) {
            if (showcaseCentral.showcaseOn) {
                switch (evt.which) {
                    case 27: showcaseCentral.showcaseEnd(); return false; break;
                    case 37: showcaseCentral.showcasePrev(); break;
                    case 39: showcaseCentral.showcaseNext(); break;
                }
            }
        });
        $(window).resize(function() {
            if (showcaseCentral.showcaseOn) showcaseCentral.showcaseEnd();
        });
        this.inited = true;
    }
}
